import $apiJSON from '../http/apiJSON'

// Events API Service

export async function getEvents(params = {}) {
  return $apiJSON.get('events/events/', { params })
}

export async function getEvent(slug) {
  return $apiJSON.get(`events/events/${slug}/`)
}

export async function getEventCategories() {
  return $apiJSON.get('events/categories/')
}

export async function getEventVenues(params = {}) {
  return $apiJSON.get('events/venues/', { params })
}

export async function registerForEvent(slug, data = {}) {
  return $apiJSON.post(`events/events/${slug}/register/`, data)
}

export async function unregisterFromEvent(slug) {
  return $apiJSON.post(`events/events/${slug}/unregister/`)
}

export async function getEventParticipants(slug) {
  return $apiJSON.get(`events/events/${slug}/participants/`)
}

export async function getMyEventRegistrations() {
  return $apiJSON.get('events/registrations/')
}

// Алиас для совместимости с новым компонентом
export async function getMyRegistrations() {
  return getMyEventRegistrations()
}

export async function getEventRegistration(id) {
  return $apiJSON.get(`events/registrations/${id}/`)
}

export async function updateEventRegistration(id, data) {
  return $apiJSON.put(`events/registrations/${id}/`, data)
}

export async function cancelEventRegistration(id) {
  return $apiJSON.delete(`events/registrations/${id}/`)
}

export async function getEventTickets() {
  return $apiJSON.get('events/tickets/')
}

export async function getEventTicket(id) {
  return $apiJSON.get(`events/tickets/${id}/`)
}

export async function useEventTicket(id) {
  return $apiJSON.post(`events/tickets/${id}/use/`)
}

export async function getUpcomingEvents() {
  return $apiJSON.get('events/events/', { 
    params: { 
      start_date__gte: new Date().toISOString().split('T')[0],
      ordering: 'start_date'
    } 
  })
}

export async function getPastEvents() {
  return $apiJSON.get('events/events/', { 
    params: { 
      end_date__lt: new Date().toISOString().split('T')[0],
      ordering: '-start_date'
    } 
  })
}

export async function getEventsByCategory(categoryId, params = {}) {
  return $apiJSON.get('events/events/', { params: { category: categoryId, ...params } })
}

export async function getEventsByVenue(venueId, params = {}) {
  return $apiJSON.get('events/events/', { params: { venue: venueId, ...params } })
}

export async function searchEvents(query) {
  return $apiJSON.get('events/events/', { params: { search: query } })
}

export async function getPopularEvents() {
  return $apiJSON.get('events/events/', { params: { ordering: '-registrations_count' } })
}

export async function getFreeEvents() {
  return $apiJSON.get('events/events/', { params: { is_free: true } })
}

export async function getEventsStats() {
  return $apiJSON.get('events/stats/')
}

// Дополнительные функции для расширенного функционала
export async function getEventReviews(eventId) {
  return $apiJSON.get(`events/events/${eventId}/reviews/`)
}

export async function addEventReview(eventId, reviewData) {
  return $apiJSON.post(`events/events/${eventId}/reviews/`, reviewData)
}

export async function addToFavorites(eventId) {
  return $apiJSON.post(`events/events/${eventId}/favorite/`)
}

export async function removeFromFavorites(eventId) {
  return $apiJSON.delete(`events/events/${eventId}/favorite/`)
}

export async function getFavoriteEvents() {
  return $apiJSON.get('events/favorites/')
}

export async function downloadTicket(ticketId) {
  return $apiJSON.get(`events/tickets/${ticketId}/download/`, {
    responseType: 'blob'
  })
}